var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "archive-paper-check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PWS-APP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Program---Samples-(CR)---Bulk-Complete",
    transform: "translate(-694.000000, -122.000000)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(468.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialogs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-Area"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-paper-check-4",
    transform: "translate(204.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-paper-check-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-paper-check-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-paper-check"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#00B5E1",
    points: "0 31.6363636 15.2727273 31.6363636 15.2727273 37.0909091 32.7272727 37.0909091 32.7272727 31.6363636 48 31.6363636"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#00B5E1",
    points: "48 13.0909091 48 30.5443636 48 48 0 48 0 30.5443636 0 13.0909091"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#00B5E1",
    points: "6.54545455 25.0909091 6.54545455 0 41.4545455 0 41.4545455 25.0909091"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#002C8B",
    points: "17.4545455 15.2727273 21.8181818 19.6363636 30.5454545 10.9090909"
  }))))))))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperCheck);
export default __webpack_public_path__ + "static/media/paper-check.e04ebb0d.svg";
export { ForwardRef as ReactComponent };